'use client';

import { useEffect } from 'react';

import { browserErrorName, reportBrowserError } from '@/lib/file-preview-telemetry';

const EXTENSION_SCHEME = /^(?:chrome|moz|safari|safari-web)-extension:/;
const RESIZE_OBSERVER_NOISE = /^ResizeObserver loop/;

export function BrowserErrorReporter(): null {
  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      if (EXTENSION_SCHEME.test(event.filename ?? '')) return;
      if (!event.error && RESIZE_OBSERVER_NOISE.test(event.message ?? '')) return;
      reportBrowserError('error', event.error ? browserErrorName(event.error) : 'OtherError');
    };
    const onRejection = (event: PromiseRejectionEvent) => {
      reportBrowserError('unhandledrejection', browserErrorName(event.reason));
    };
    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);
    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, []);

  return null;
}
